import React, { useState } from 'react';
import { auth } from '../../../firebase';
import { sendPasswordResetEmail } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import '../login_page/forgot_password.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleReset = async (e) => {
    e.preventDefault();
    setLoading(true);

    const actionCodeSettings = {
      url: 'https://parm.com.my/auth-handler', // 👈 Your actual domain route
      handleCodeInApp: true,
    };

    try {
      // Pass settings as second argument
      await sendPasswordResetEmail(auth, email);
      alert("A reset link has been sent to your email address! Please check spam folder.");
      navigate('/login-parm'); 
    } catch (error) {
      console.error(error);
      alert("Error: " + error.message);
    } finally {
      setLoading(false);
    }
  };
    
    // try {
    //   await sendPasswordResetEmail(auth, email);
    //   alert("A reset link has been sent to your email address! Please check spam folder");
    //   // Optionally redirect them back to login so they are ready when they finish
    //   navigate('/login-parm'); 
    // } catch (error) {
    //   console.error(error);
    //   alert("Error: " + error.message);
    // } finally {
    //   setLoading(false);
    // }

  return (
    <div className="forgot-password-container">
      <form className="forgot-form" onSubmit={handleReset}>
        <h2>Reset Password</h2>
        <p>Enter the email associated with your PArM account.</p>

        <div className="input-group-forgot-form">
          <label>Email Address</label>
          <input 
            type="email" 
            placeholder="example@mail.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required 
          />
        </div>

        <button type="submit" className="reset-btn-forgotpass" disabled={loading}>
          {loading ? "Sending..." : "Send Reset Link"}
        </button>

        <button type="button" className="back-btn-forgotpass" onClick={() => navigate('/login-parm')}>
          Back to Login
        </button>
      </form>
    </div>
  );
};

export default ForgotPassword;